import * as React from "react";
import { Modal, ModalBody } from 'reactstrap';


class YesNoComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { showModal, modalText, modalYesFunction, modalNoFunction, YesParameter, NoParameter, yesText, noText } = this.props;

        return (
            showModal &&
            <Modal className="verify-modal" isOpen={showModal} centered>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <p dangerouslySetInnerHTML={{ __html: modalText }} ></p>
                            <div className="row link-container">
                                <div className="col-6 link-left" onClick={() => modalYesFunction(YesParameter)}>{yesText || 'YES'}</div>
                                <div className="col-6 link-right" onClick={() => modalNoFunction(NoParameter)}>{noText || 'NO'}</div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }


}


export default YesNoComponent;